import { reportApi } from '../http/httpClient'

export interface ReportSellers {
  name: string
  cpf: string
  email: string
  phone: string
  team_name?: string
  transactions: number
  transaction_value: number
  commission: number
  withdraw: number
  withdraw_value: number
  createdAt: string

  instagram?: string
  manager?: string
  supervisor?: string
  leader?: string
}

export interface ReportSellersResponse {
  sellers: ReportSellers[]
  pagination: {
    skip: number
    limit: number
    sort: string
    total: number
  }
}

export interface ReportSellersParams {
  search?: string
  sellerIds?: string
  teamIds?: string
  startDate?: string
  endDate?: string
  maxValue?: string
  minValue?: string
  minSales?: string
  maxSales?: string
  limit?: number
  skip?: number
  sort?: string
}

export async function reportSellers(params?: ReportSellersParams | undefined) {
  const { data } = await reportApi.get<ReportSellersResponse>(
    '/report/sellers',
    {
      params,
    },
  )

  return data
}
